import { getNow } from '../utils/getNow';
import { getFallbackValueIfNull } from 'owa-options-core';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
import {
    lazyUserInitiatedWebPushSetupWorkflow,
    lazyUserInitiatedWebPushDisableWorkflow,
    getLocalWebPushUserSettingStore,
    LocalWebPushUserSetting,
    logEnableStart,
    logDisableStart,
    logWorkFlowEnd,
} from 'owa-webpush-notifications';
import {
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    WebPushNotificationsOptions,
} from 'owa-outlook-service-options';

export interface SaveWebPushNotificationsOptionState {
    userOptions?: WebPushNotificationsOptions;
    localWebPushUserSetting: LocalWebPushUserSetting;
    windowObj: Window;
}

let saveWebPushNotificationsOptions = select<SaveWebPushNotificationsOptionState>({
    userOptions: () =>
        getOptionsForFeature<WebPushNotificationsOptions>(
            OwsOptionsFeatureType.WebPushNotifications
        ),
    localWebPushUserSetting: () => getLocalWebPushUserSettingStore(),
    windowObj: () => window,
})(
    action('saveWebPushNotificationsOptions')(async function saveWebPushNotificationsOptions(
        isEnabledOnMachineOverride?: boolean,
        state?: SaveWebPushNotificationsOptionState
    ) {
        let { userOptions, localWebPushUserSetting, windowObj } = state;
        if (userOptions.applicationServerKey == null) {
            return;
        }

        localWebPushUserSetting.enabled = getFallbackValueIfNull(
            isEnabledOnMachineOverride,
            localWebPushUserSetting.enabled
        );
        if (!userOptions.enabled) {
            // If it is yet not enabled, then it might be a request to enable for first time, update the server state to enabled as well.
            userOptions.enabled = getFallbackValueIfNull(
                isEnabledOnMachineOverride,
                userOptions.enabled
            );
            userOptions.enabledTimeInUTCMs = getNow().toString();
            await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
                OwsOptionsFeatureType.WebPushNotifications,
                userOptions
            );
        }

        let mbxGuid = getUserConfiguration().SessionSettings.MailboxGuid;
        if (userOptions.enabled && localWebPushUserSetting.enabled) {
            let userInitiatedWebPushSetupWorkflow = await lazyUserInitiatedWebPushSetupWorkflow.import();
            logEnableStart('settings');
            let enabled = await userInitiatedWebPushSetupWorkflow(
                windowObj,
                userOptions,
                mbxGuid,
                true
            );
            logWorkFlowEnd(enabled);
        } else {
            let userInitiatedWebPushDisableWorkflow = await lazyUserInitiatedWebPushDisableWorkflow.import();
            logDisableStart('settings', false);
            let disabled = await userInitiatedWebPushDisableWorkflow(
                windowObj,
                userOptions,
                mbxGuid,
                false
            );
            logWorkFlowEnd(disabled);
        }
    })
);

export default saveWebPushNotificationsOptions;

export function saveWebPushNotificationsOptionsQuick(isEnabledOnMachine: boolean) {
    saveWebPushNotificationsOptions(isEnabledOnMachine);
}
